// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quicksight-container {
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.quicksight-container .qs-details-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}
.quicksight-container .qs-details-header__title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.quicksight-container .qs-details-header h2 {
  margin: 0;
  color: #333;
  font-weight: 600;
  line-height: 1.2;
}
.quicksight-container .qs-details-header__subtitle {
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.9rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  word-break: break-all;
}
.quicksight-container .dashboard-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.quicksight-container .dashboard-content .loading-container,
.quicksight-container .dashboard-content .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}
.quicksight-container .dashboard-content .loading-container .loading-spinner,
.quicksight-container .dashboard-content .loading-container .error-icon,
.quicksight-container .dashboard-content .error-container .loading-spinner,
.quicksight-container .dashboard-content .error-container .error-icon {
  margin-bottom: 1rem;
}
.quicksight-container .dashboard-content .loading-container p,
.quicksight-container .dashboard-content .error-container p {
  color: #666;
  margin: 0.5rem 0;
}
.quicksight-container .dashboard-content .loading-container h3,
.quicksight-container .dashboard-content .error-container h3 {
  margin: 1rem 0 0.5rem 0;
  color: #333;
}
.quicksight-container .dashboard-content .iframe-container {
  flex: 1;
  width: 100%;
  height: 800px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
}
.quicksight-container .dashboard-content .iframe-container ::ng-deep > iframe {
  height: 100%;
  width: 100%;
}

@media (max-width: 768px) {
  .quicksight-container {
    padding: 0.5rem;
  }
  .quicksight-container .qs-details-header {
    align-items: flex-start;
    gap: 0.5rem;
  }
}
.quicksight-container {
  height: 1750px;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
